var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.events.length > 0)?_c(_setup.PriceChart,{attrs:{"price-chart-data":_setup.chartData,"chart-height":"350px"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }